export default __webpack_public_path__ + "assets/111b7b74f20b652acd1e5ae806646ac4.jpg";